import {hotelName} from './helper'

export const defaultFiltererHotel = (item, filter, typesRating) => {
  let checkRating = true
  let checkPrezzo = true
  let checkNome = true

  // filter by rating
  if (filter.rating) {
    const hotelRating = typesRating.find(elem => {
      return elem.type === item.hotel.summary.rate
    }).value
    checkRating = filter.rating === hotelRating
  }

  // filter by price
  if (filter.prezzo) {
    const itemPrice = item.venditaTotaleEuro
    checkPrezzo = itemPrice >= filter.prezzo[0] && itemPrice <= filter.prezzo[1]
  }

  // filter by name
  if (filter.nome) {
    const name = hotelName(item.hotel.location.name).toLowerCase()
    const filterName = filter.nome.toLowerCase()
    checkNome = name.indexOf(filterName) >= 0
  }
  return checkRating && checkPrezzo && checkNome
}

export const defaultSorterHotel = (a, b, order) => {
  const delta = a.venditaTotaleEuro - b.venditaTotaleEuro
  return order.prezzo === 'up' ? delta : -1 * delta
}



// WEBPACK FOOTER //
// ./src/front/utils/hotelUtils.js